const GOOGLE_MAPS_API_KEY = 'AIzaSyAbo27E_1VWZ8qjveBimYmbwAy5enObc_g';

export {
  GOOGLE_MAPS_API_KEY,
};



// WEBPACK FOOTER //
// ./src/lib/AppConstants.js